import { DescriptorType } from '@fabric-ui/components';
import { FormatterType, MeasurementCategory, MeasurementUnit, TimeBucket } from '@fabric-ui/components/Table';
import { Measurement } from '../Measurements/types';
import { FieldType, FieldTypeEnum, FieldType as MappingFieldType } from '../Sources/Mapping/types';

const isNumber = (entityFieldKey: string, fieldTypeMap: Record<string, string>, measurement?: Measurement) =>
  FieldTypeEnum[fieldTypeMap[entityFieldKey]] === MappingFieldType.Number ||
  measurement?.category === MeasurementCategory.NUMERIC ||
  measurement?.category === MeasurementCategory.POPULATION_COUNT ||
  FieldTypeEnum[DescriptorType[measurement?.type || 'none']] === FieldType.Number ||
  FieldTypeEnum[measurement?.type || 'none'] === FieldType.Number;

const isPercentage = (measurement?: Measurement) =>
  measurement?.category === MeasurementCategory.PERCENTAGE ||
  (measurement?.category === MeasurementCategory.MATH_EXPRESSION && measurement?.unit.name === MeasurementUnit.Percentage);

const isDate = (entityFieldKey: string, fieldTypeMap: Record<string, string>, measurement?: Measurement) =>
  [MappingFieldType.DateTime, MappingFieldType.Date].includes(FieldTypeEnum[fieldTypeMap[entityFieldKey]] as any) ||
  [MappingFieldType.DateTime, MappingFieldType.Date].includes(FieldTypeEnum[measurement?.type as any] as any);

const isHistoricDate = (entityFieldKey: string) => TimeBucket[entityFieldKey];

export const getFieldType = ({
  entityFieldKey,
  measurements,
  fieldTypeMap,
}: {
  entityFieldKey: string;
  measurements: Measurement[];
  fieldTypeMap: Record<string, string>;
}): FormatterType | (typeof FieldType)['FIX'] | undefined => {
  const maybeMeasurement = measurements.find(({ systemName }) => systemName === entityFieldKey);
  return isPercentage(maybeMeasurement)
    ? FormatterType.percentage
    : isNumber(entityFieldKey, fieldTypeMap, maybeMeasurement)
      ? FormatterType.number
      : isDate(entityFieldKey, fieldTypeMap, maybeMeasurement)
        ? FormatterType.date
        : isHistoricDate(entityFieldKey)
          ? FormatterType.historicDate
          : Array.isArray(fieldTypeMap[entityFieldKey])
            ? FormatterType.array
            : FieldTypeEnum[fieldTypeMap[entityFieldKey]] === MappingFieldType.Message
              ? FormatterType.json
              : FieldTypeEnum[fieldTypeMap[entityFieldKey]] === MappingFieldType.Boolean
                ? FormatterType.boolean
                : FieldTypeEnum[fieldTypeMap[entityFieldKey]] === MappingFieldType.FIX
                  ? FieldType.FIX
                  : undefined;
};
